import { createSelector, createFeatureSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { RouterStateUrl } from './router.state';

export const routerSelector = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getBookIdFromUrl = createSelector(routerSelector, (state: RouterReducerState<RouterStateUrl>) => state.state.params['bookId']);
